<section class="error-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <h1 i18n="@@featureErrors-pageServiceUnavailable-headline">Wir sind gleich zurück</h1>
        <ng-container i18n="@@featureErrors-pageServiceUnavailable-text">
          <p>
            Dieser Inhalt wird gerade von uns überarbeitet. Doch das Warten lohnt sich, denn wir machen diesen Bereich
            noch besser!
          </p>
          <p>
            <b>In Kürze</b>
            stehen Ihnen alle Funktionen wieder zur Vefügung.
          </p>
        </ng-container>
      </div>
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone error-page-image-wrapper">
        <img src="assets/errors/maintainance.svg" class="error-page-image" />
      </div>
    </div>
  </div>
</section>
